/* eslint-disable no-console */
<template>
<div>
    <div class="card z-depth-5 p-3">
        <h4 class="text-center font-weight-bold py-3">Add Homework</h4>
        <div>
            <!-- Default form login -->
            <form class="border border-light p-5">
                <div class="row">
                    <div class="form-group col-12 pt-3 ">
                        <div class="divider1">
                            <h5 class="font-weight-bold">Formulae</h5>
                        </div>

                    </div>
                    <div class="form-group col-md-6">
                       <div class="row">
                        <div class="form-group col-md-6">
                        <label>Category</label>
                        <select ref="formulaCategory" class="form-control form-control-sm mb-4" @change="changeFormulae">
                            <option value="little friend">Little Friend</option>
                            <option value="big friend">Big Friend</option>
                            <option value="grand family">Grand Family</option>
                            <option value="multiplication">Multiplication</option>
                            <option value="division">Division</option>
                            <option value="random">Random</option>
                            <option value="equation">Equation</option>
                        </select>
                    </div>
                         <div class="form-group col-md-6" v-if="!showRow">
                            <label>Central</label>
                            <input type="number" ref="formulaCentral"  class="form-control form-control-sm mb-4" placeholder="Value">
                        </div>
                        <div class="form-group col-md-6" v-if="!showRow">
                            <label>Focus</label>
                            <input type="number" ref="formulaFocus"  class="form-control form-control-sm mb-4" placeholder="Value">
                        </div>
                        
                        <div class="form-group col-md-6" v-if="showRow">
                                <label>Pattern</label>
                                <input type="text" id="" ref="pattern" class="form-control mb-4" placeholder="pattern eg. 1×2, 2/1 or (AAxBB)/CC">
                            </div>
                       </div>
                        
                        <div class="form-group" >
                            <button class="btn btn-black btn-block mt-4" @click.prevent="addFormula()">Add Formula</button>
                           
                        </div>
                    </div>
                    <div class="form-group col-md-6 divider1-color white-text">
                        <div class="form-group col-12">
                            <h6 class="font-weight-bold pt-3">Added Formulae</h6>
                            <table class="table">
                                <thead>
                                    <tr class="white-text text-muted">
                                         <th scope="col">Category</th>
                                        <th scope="col">Central</th>
                                        <th scope="col">Focus</th>
                                        <th scope="col">Pattern</th>
                                        
                                        <th scope="col">Remove</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="white-text text-muted" v-for="(formula, index) in formulae" :key="index">
                                        <td>{{formula.category}}</td>
                                        <td>{{formula.central ? formula.central : "-"}}</td>
                                        <td>{{formula.focus ? formula.focus : "-"}}</td>
                                        <td>{{formula.pattern ? formula.pattern : "-"}}</td>
                                         
                                        <td>
                                            <button class="btn btn-danger btn-sm" @click.prevent="removeTask('formulae',index)">Remove</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="form-group col-md-12">
                        <label>Lesson Title</label>
                        <input type="text" ref="title"  class="form-control mb-4" placeholder="Lesson Title">
                    </div>
                    <div class="col-md-8">
                        <div class="row">
                            <div class="form-group col-md-4">
                                <label>Minimum</label>
                                <input type="number" ref="min" id="" class="form-control mb-4" placeholder="Min">
                            </div>
                            <div class="form-group col-md-4">
                                <label>Maximum</label>
                                <input type="number" ref="max" id="" class="form-control mb-4" placeholder="Max">
                            </div>
                            <div class="form-group col-md-4">
                                <label>Rows</label>
                                <input type="number" id="" ref="cols" class="form-control mb-4" placeholder="Rows">
                            </div>
                            

                            <div class=" form-group col-md-4 ">
                                <label>Step</label>
                                <input type="number" ref="step" id="" class="form-control mb-4" placeholder="Step">
                            </div>
                            <div class=" form-group col-md-4">
                                <label>Group</label>
                                <input type="number" ref="group" id="" class="form-control mb-4" placeholder="Group">
                            </div>
                            <div class=" form-group col-md-4">
                                <label>Decimal</label>
                                <select ref="decimal" class="form-control form-control-sm mb-4">
                                <option value="false">No</option>
                                <option value="true">Yes</option>
                            </select>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class=" form-group">
                            <label>Select Operations (Multiple Operators can be selected)</label>
                            <select v-model="operations" class="form-control" multiple>
                                <option value="+">Addition (+)</option>
                                <option value="-">Subtraction (-)</option>
                                <option value="/">Division (/)</option>
                                <option value="*">Multiplication (*)</option>
                            </select>
                            
                        </div>
                        <div class="divider2-color white-text mt-2 p-2" v-if="operations.length > 0">
                            Selected Operators : {{operations}}
                        </div>
                    </div>


                    <div class="form-group col-12 ">
                        <div class="divider2">
                            <h5 class="font-weight-bold ">Add Homework</h5>
                        </div>
                    </div>
                    <div class="form-group col-md-6">
                        <div class="form-group">
                            <label>Day</label>
                            <input type="number" ref="homeDay" id="" class="form-control form-control-sm mb-4" placeholder="Day">
                        </div>
                        <div class="form-group">
                            <label>Value</label>
                            <input type="number" ref="homeValue" id="" class="form-control form-control-sm mb-4" placeholder="Value">
                        </div>
                        <div class="form-group ">
                            <label>Type</label>
                            <select ref="homeType" class="form-control form-control-sm mb-4">
                                <option value="a">Audio</option>
                                <option value="s">Static</option>
                                <option value="f">Flash</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <span class="btn btn-black  btn-block mt-4" @click.prevent="addHomework()">Add Homework</span>
                        </div>
                    </div>
                    <div class="form-group col-md-6 divider2-color white-text pt-3">
                        <h6 class="font-weight-bold">Added Homeworks</h6>
                        <table class="table">
                            <thead>
                                <tr class="white-text text-muted">
                                    <th scope="col">Day</th>
                                    <th scope="col">Value</th>
                                    <th scope="col">Type</th>
                                    <th scope="col">Remove</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="white-text text-muted" v-for="(homework, index) in homeworks" :key="index">
                                    <td>{{homework.day}}</td>
                                    <td>{{homework.value}}</td>
                                    <td>{{homework.type}}</td>
                                    <td>
                                        <span class="btn btn-danger btn-sm" @click="removeTask('homeworks',index)">Remove</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    

                </div>

                <!-- Sign in button -->
                <button class="btn btn-info btn-block my-4" @click.prevent="addLesson()">Add Homework</button>

            </form>
            <!-- Default form login -->
        </div>
    </div>
</div>
</template>

<style scoped>
.divider1 {
    padding: 10px;
    background: #1C2331;
    width: 80%;
    color: #fff;
}

.divider1-color {

    background: #1C2331;

}

.divider2 {
    padding: 10px;
    background: #344C6E;
    width: 80%;
    color: #fff;
}

.divider2-color {
    background: #344C6E;
}
</style>

<script>
import axios from "axios"
export default {
    name: 'AddHomework',
    data() {
        return {
            homeworks: [],
            classworks: [],
            operations : [],
            formulae: [],
            level_id: this.$route.params.levelId,
            fastAdminToken : localStorage.getItem("fastAdminToken"),
            showRow: false
        }
    },
    methods: {
        changeFormulae(){
            if(this.$refs.formulaCategory.value == "multiplication" || this.$refs.formulaCategory.value == "division" || this.$refs.formulaCategory.value == "equation"){
                this.showRow = true;
            }else{
                this.showRow = false;
            }
            
        },

        addFormula() {
            if(this.$refs.formulaCategory.value == "multiplication" || this.$refs.formulaCategory.value == "division" || this.$refs.formulaCategory.value == "equation"){
                let newFormula = {
                    'category': this.$refs.formulaCategory.value,
                    'pattern': this.$refs.pattern.value
                }
                this.formulae.push(newFormula);
                // eslint-disable-next-line no-console
                // console.log(this.classworks)
                this.$toast.open({
                    message: "New Formula Added",
                    type: 'info',
                    // all of other options may go here
                });
            }

            else if ((this.$refs.formulaCentral.value == "" || this.$refs.formulaFocus.value == "" || this.$refs.formulaCategory.value == "") && this.$refs.formulaCategory.value != "random" && this.$refs.formulaCategory.value != "multiplication" && this.$refs.formulaCategory.value != "division"  ) {
                this.$toast.open({
                    message: "Formula Central, Focus and Category are required",
                    type: 'error',
                    // all of other options may go here
                });
            }
            
            
            else {
                let newFormula = {
                    'category': this.$refs.formulaCategory.value,
                    'central': this.$refs.formulaCentral.value != "" ? parseInt(this.$refs.formulaCentral.value) : 0,
                    'focus': this.$refs.formulaFocus.value != "" ? parseInt(this.$refs.formulaFocus.value):  0
                    
                }
                this.formulae.push(newFormula);
                // eslint-disable-next-line no-console
                // console.log(this.classworks)
                this.$toast.open({
                    message: "New Formula Added",
                    type: 'info',
                    // all of other options may go here
                });
            }
        },

        addHomework() {
            if (this.$refs.homeValue.value == "") {
                this.$toast.open({
                    message: "Homework Type and Value are required",
                    type: 'error',
                    // all of other options may go here
                });
            } else {
                let newHomework = {
                    'day': parseInt(this.$refs.homeDay.value),
                    'value': parseInt(this.$refs.homeValue.value),
                    'type': this.$refs.homeType.value,
                }
                this.homeworks.push(newHomework);
                // eslint-disable-next-line no-console
                // console.log(this.homeworks)
                this.$toast.open({
                    message: "New Homework Added",
                    type: 'info',
                    // all of other options may go here
                });
            }
        },
        removeTask(taskName, index) {
            if (taskName == 'homeworks') {
                this.homeworks.pop(index)
                this.$toast.open({
                    message: "Removed",
                    type: 'info',
                    // all of other options may go here
                });

            }

            if (taskName == 'classworks') {
                this.classworks.pop(index)
                this.$toast.open({
                    message: "Removed",
                    type: 'info',
                    // all of other options may go here
                });
            }

            if (taskName == 'formulae') {
                this.formulae.pop(index)
                this.$toast.open({
                    message: "Removed",
                    type: 'info',
                    // all of other options may go here
                });
            }

        },
        addLesson() {
            
            let data = {
                title : this.$refs.title.value,
                min: parseInt(this.$refs.min.value),
                max: parseInt(this.$refs.max.value),
                operations : this.operations,
                formulae : this.formulae,
                classwork: this.classworks,
                homework: this.homeworks,
                isDecimal: this.$refs.decimal.value,
                step: parseInt(this.$refs.step.value),
                group: parseInt(this.$refs.group.value)
            }
            if(this.$refs.cols){
                data.cols =  parseInt(this.$refs.cols.value)
            }
            
            const config = {
                headers: {
                    Authorization: "Bearer " + this.fastAdminToken,
                    'Content-Type': 'application/json'
                }
            }
            

            this.$toast.open({
                message: "Processing : Creating Lesson Please Wait...",
                type: 'info'
            })

            axios.post(this.$apiURI + "/levels/" + this.level_id + "/lesson/create", data, config)
                .then((response) => {
                    if (response.data.error) {
                        this.$toast.open({
                            message: "Error : " + response.data.message,
                            type: 'error'
                        });
                    } else {
                        this.$toast.open({
                            message: "Lesson Created Successfully",
                            type: 'success'
                        })
                    }

                }).catch((error) => {
                    this.$toast.open({
                        message: "Error : " + error.response.data.message,
                        type: 'error'
                    });
                })
        }
    }
}
</script>
